import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Typography, Space, Row, Col, Image } from 'antd';
import styles from './AppFooter.module.scss';
import logoImage from '@/assets/logo_bottom.png';
import policeBadge from '@/assets/12.jpg';
import wxCm from '@/assets/wx_cm.jpg';
import wxCmzj from '@/assets/wx_cmzj.jpg';

const { Footer } = Layout;
const { Text } = Typography;

export const AppFooter: React.FC = () => {
  const friendlyLinks = [
    { label: '国家药品监督管理局', url: 'https://www.nmpa.gov.cn/' },
    { label: '广东省药品监督管理局', url: 'https://mpa.gd.gov.cn/' },
    { label: '广州市市场监督管理局', url: 'https://scjgj.gz.gov.cn/' },
    { label: '汕头市市场监督管理局', url: 'https://www.shantou.gov.cn/scjgj/' },
    { label: '佛山市市场监督管理局', url: 'https://fsamr.foshan.gov.cn/' },
    { label: '惠州市市场监督管理局', url: 'https://hzamr.huizhou.gov.cn/' },
    { label: '珠海市市场监督管理局', url: 'https://www.zhuhai.gov.cn/scjgj/gkmlpt/index' },
    { label: '深圳市市市场监督管理局', url: 'https://amr.sz.gov.cn/' },
  ];

  return (
    <Footer className={styles.footer}>
      {/* 第一行：左侧公司信息，右侧二维码 */}
      <div className={styles.firstRowBg}>
        <div className={styles.container}>
          <Row gutter={[48, 32]} align="top" className={styles.firstRow}>
            <Col xs={24} sm={12} md={16}>
              <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <div className={styles.logoRow}>
                  <Link to="/" className={styles.logo}>
                    <img src={logoImage} alt="创美药业" />
                  </Link>
                  
                  <div className={styles.companyInfo}>
                    <Text className={styles.companyDesc}>
                      股份代号 2289.HK
                    </Text>
                  </div>
                </div>
                
                <Text type="secondary" className={styles.copyright}>
                  Copyright 2014 創美藥業 粤ICP备12091553号 互联网药品信息服务资格证书：（粤）-非经营性-2022-0202
                </Text>
              </Space>
            </Col>

            <Col xs={24} sm={12} md={8} className={styles.qrCodeCol}>
              <div className={styles.qrCodesContainer}>
                <div className={styles.qrCodeWrapper}>
                  <Image 
                    src={wxCm} 
                    alt="创美药业" 
                    className={styles.qrCodeImage}
                    preview={{
                      mask: '点击扫码',
                    }}
                  />
                  <Text className={styles.qrCodeText}>创美药业</Text>
                </div>
                <div className={styles.qrCodeWrapper}>
                  <Image 
                    src={wxCmzj} 
                    alt="创美之家" 
                    className={styles.qrCodeImage}
                    preview={{
                      mask: '点击扫码',
                    }}
                  />
                  <Text className={styles.qrCodeText}>创美之家</Text>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* 第二行：友情链接 */}
      <div className={styles.secondRowBg}>
        <div className={styles.container}>
          <div className={styles.friendlyLinks}>
            <Text className={styles.friendlyLinksTitle}>友情链接：</Text>
            <div className={styles.linksContainer}>
              {friendlyLinks.map((link, index) => (
                <React.Fragment key={link.url}>
                  <a 
                    href={link.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={styles.friendlyLink}
                  >
                    {link.label}
                  </a>
                  {index < friendlyLinks.length - 1 && <span className={styles.linkSeparator}>|</span>}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* 第三行：公安备案 */}
          <div className={styles.policeRegistration}>
            <a 
              href="https://beian.mps.gov.cn/#/query/webSearch" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.policeLink}
            >
              <img src={policeBadge} alt="公安备案" className={styles.policeBadge} />
              <span>粤公网安备 44060402002640号</span>
            </a>
          </div>
        </div>
      </div>
    </Footer>
  );
};
